export const getAuthUrl = (baseUrl: string) => {
  const authUrl = `${baseUrl}/auth`
  return {
    LOGIN_URL: (provider: string) => `${authUrl}/${provider}/login-url`,
    HANDLE_CALLBACK: (provider: string) => `${authUrl}/${provider}/callback`,
    REFRESH_TOKEN: () => `${authUrl}/refresh`,
    DASHBOARD: () => `${authUrl}/dashboard`,
    WITH_REDIRECT: (provider: string) => `${authUrl}/${provider}/login-url-with-redirect`,
    CHECK_TOKEN: () => `${authUrl}/verify`,
    TEST_USERS: () => `${authUrl}/test-users`,
    TEST_LOGIN: () => `${authUrl}/test-login`,
    ADD_TEST_MEMORY: () => `${authUrl}/main/test-memory-add`
  }
}
